
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {  ActivatedRoute } from '@angular/router';


import { RequirementService } from 'src/app/services/requirement.service';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import { SendingIdService } from 'src/app/services/sending-id.service';

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.scss'],
    standalone: false
})
export class CalendarComponent implements OnInit {
	@Output() closeCalendar = new EventEmitter<boolean>();
	// var for messages
	@Input() requirementId: number;
	@Input() idUrlAditional: number;

  constructor(
		public activeModal: NgbActiveModal,
		private activatedRoute: ActivatedRoute,
		public _requirements: RequirementService,
		private sendIdServ: SendingIdService,
	) { }

  ngOnInit() {
	}
	closeModal() {
		this.activeModal.close('Modal Closed');
		this.closeCalendar.emit(true);
	}
}
